import React from 'react';

import SubCategoryProducts from '../components/content/our-products/sub-category-products';

const SubCategoryProductsTemplate = ({ pageContext, location }) => {
  return <SubCategoryProducts {...pageContext} location={location} />;
};

export default SubCategoryProductsTemplate;
